module.exports = __webpack_public_path__ + "static/img/16.7d02d11.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/7/1/3/zh/16.png
// module id = Lr0C
// module chunks = 0